export enum AddonActions {
  CREATE_ROW = 'a0',
  READ_TABLE = 'a1',
  READ_RECORDS = 'a2'
}
